import { Skeleton } from '@ghq-abi/design-system-v2';

interface SkeletonsProp {
  quantity?: number;
  height?: string | number;
  width?: string | number;
  className?: string;
}

export function Skeletons({
  quantity = 1,
  height,
  width = '100%',
  className = ''
}: SkeletonsProp) {
  return (
    <>
      {Array.from({ length: quantity }, (_, i) => i).map(i => (
        <Skeleton
          key={i}
          className={className}
          style={{ width, minHeight: height }}
        />
      ))}
    </>
  );
}
